// assets/sc-brand-peek-fix.js
(function () {
  var MB_MAX = 767;

  function unslickSafe($el){
    if ($el && $el.length && $el.hasClass('slick-initialized')) {
      try { $el.slick('unslick'); } catch(e) {}
    }
  }

  function clearInlineWidths($slider){
    $slider.find('.halo-item').each(function(){
      this.style.width = '';     // ✅ 清掉 46vw 这种残留
    });
  }

  function initMobilePeek($slider){
    // 只处理 2列的 slider
    if (!$slider.hasClass('sm-column-2')) return;

    // 防重复
    if ($slider.data('scPeekFixed')) return;
    $slider.data('scPeekFixed', true);

    // 先销毁主题原 init
    unslickSafe($slider);

    // 给每个 item 真宽度（只在移动端）
    $slider.find('.halo-item').css('width', '42vw'); // 露多/少改这里

    // 用 variableWidth 重建
    $slider.slick({
      variableWidth: true,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      swipeToSlide: true,
      speed: 300
    });
  }

  function restoreDesktop($slider){
    // ✅ PC 端：把我们做过的东西清理掉
    $slider.removeData('scPeekFixed');

    // 先销毁我们重建过的 slick
    unslickSafe($slider);

    // 清掉 inline width
    clearInlineWidths($slider);

    // ✅ 让主题原本的 halo.slide-brand.js 自己再初始化一次
    // 有些主题会自动重init；如果没自动，就手动触发一次 resize
    setTimeout(function(){ window.dispatchEvent(new Event('resize')); }, 0);
  }

  function run(){
    if (!window.jQuery) return;
    var $ = window.jQuery;

    $('.brand-slider .brands-slider').each(function(){
      var $slider = $(this);

      if (window.innerWidth <= MB_MAX){
        initMobilePeek($slider);
      } else {
        restoreDesktop($slider);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('resize', function(){
    // 防抖一点点
    clearTimeout(window.__scBrandPeekT);
    window.__scBrandPeekT = setTimeout(run, 120);
  });
  document.addEventListener('shopify:section:load', run);
})();
